var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 28.0001C56.4869 28.0001 64.6263 31.3715 70.6274 37.3727C76.6286 43.3738 80 51.5132 80 60.0001C80 68.487 76.6286 76.6263 70.6274 82.6275C64.6263 88.6287 56.4869 92.0001 48 92.0001C39.5131 92.0001 31.3737 88.6287 25.3726 82.6275C19.3714 76.6263 16 68.487 16 60.0001C16 51.5132 19.3714 43.3738 25.3726 37.3727C31.3737 31.3715 39.5131 28.0001 48 28.0001V28.0001ZM48 36.0001C41.6348 36.0001 35.5303 38.5287 31.0294 43.0295C26.5286 47.5304 24 53.6349 24 60.0001C24 66.3653 26.5286 72.4698 31.0294 76.9707C35.5303 81.4715 41.6348 84.0001 48 84.0001C54.3652 84.0001 60.4697 81.4715 64.9706 76.9707C69.4714 72.4698 72 66.3653 72 60.0001C72 53.6349 69.4714 47.5304 64.9706 43.0295C60.4697 38.5287 54.3652 36.0001 48 36.0001ZM48 42.0001L53.292 52.7201L65.12 54.4401L56.56 62.7801L58.58 74.5641L48 69.0001L37.42 74.5601L39.44 62.7801L30.88 54.4361L42.708 52.7161L48 42.0001ZM72 8.00009V20.0001L66.548 24.5521C62.0238 22.1784 57.0843 20.6994 52 20.1961V8.00009H72ZM44 7.99609V20.1961C38.9174 20.6987 33.9793 22.1763 29.456 24.5481L24 20.0001V8.00009L44 7.99609Z",
    fill: "white",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensed);
export default __webpack_public_path__ + "static/media/licensed.67a19b0143aa40037b68090d62e24db2.svg";
export { ForwardRef as ReactComponent };